import React from 'react';
import { Paper, Typography, Box, TextField, FormControl, InputLabel, Select, MenuItem, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

interface Props {
  selectedProducts: any[];
  formik: any;
  handleQuantityChange: (e: any, key: string) => void;
  handleUnitChange: (e: any, key: string) => void;
  handleRemoveProduct: (key: string) => void;
  getAllowedUnits: (...args: any[]) => string[];
}

export const SelectedProductsList: React.FC<Props> = ({
  selectedProducts,
  formik,
  handleQuantityChange,
  handleUnitChange,
  handleRemoveProduct,
  getAllowedUnits,
}) => {
  if (!selectedProducts || selectedProducts.length === 0) return null;

  return (
    <Box mt={3}>
      <Typography variant="subtitle1" gutterBottom>
        Produtos Selecionados - Informe a quantidade para cada: *
      </Typography>
      {selectedProducts.filter(product => product && product.name).map((product, index) => {
        const key = product.id ?? product.uuid ?? `temp-${index}`;
        if (!product.name) return null;
        const quantityError = !product.quantity || product.quantity <= 0;
        const unitError = !product.unit;

        return (
          <Paper
            key={key}
            elevation={1}
            sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mt: 2, p: 2 }}
          >
            <Typography variant="body1" sx={{ flex: 1, pt: 2 }}>{product.name}</Typography>
            <Box sx={{ minWidth: 120 }}>
              <TextField
                type="number"
                size="small"
                label="Quantidade *"
                value={product.quantity ?? ''}
                onChange={(e) => handleQuantityChange(e, key)}
                error={quantityError && formik.submitCount > 0}
                helperText={quantityError && formik.submitCount > 0 ? 'Campo obrigatório' : ''}
                InputProps={{ inputProps: { min: 0.01, step: '0.01', 'data-testid': `product-quantity-${key}` } }}
                fullWidth
              />
            </Box>
            <Box sx={{ minWidth: 150 }}>
              <FormControl fullWidth error={unitError && formik.submitCount > 0}>
                <InputLabel size="small">Unidade *</InputLabel>
                <Select size="small" value={product.unit ?? ''} onChange={(e) => handleUnitChange(e, key)} label="Unidade *" inputProps={{ 'data-testid': `product-unit-${key}` }}>
                  {getAllowedUnits(product.name, product.production_type, product.is_processed, product.product_type).map((value) => (
                    <MenuItem key={value} value={value}>{value}</MenuItem>
                  ))}
                </Select>
                {unitError && formik.submitCount > 0 && (<Box component="div" sx={{ color: 'error.main', mt: 0.5 }}>Campo obrigatório</Box>)}
              </FormControl>
            </Box>
            <IconButton color="error" onClick={() => handleRemoveProduct(key)} size="small" sx={{ mt: 1 }} data-testid={`product-remove-${key}`}>
              <DeleteIcon />
            </IconButton>
          </Paper>
        );
      })}
    </Box>
  );
};

export default SelectedProductsList;
